import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const DivShadow = ({ children, className, ...props }: Props) => {
  return (
    <div className={`w-full shadow-elevationShadow4 dark:shadow-elevationShadow4Dark ${className}`} {...props}>
      {children}
    </div>
  );
};

export default DivShadow;
